<template>
  <div role="contentinfo">
    <div class="flex flex-wrap items-center justify-between p-6 bg-polgrey">
      <div class="container max-w-5xl mx-auto mt-1 font-semibold text-center">
        <p>QuickCheck powered by <CapitalOneLogo alt="Capital One" class="inline-block h-10 ml-1 capital-one-logo"/></p>
      </div>
    </div>
    <div class="flex flex-wrap items-center justify-between p-6 border-b border-polgrey-medium">
      <div class="container max-w-5xl mx-auto text-m">
        <p class="pt-2">
          Mastercard<sup>®</sup> and the Mastercard Symbol are registered trademarks of Mastercard International Incorporated.
        </p>
        <p class="pt-4">
          Capital One<sup>®</sup> is a registered trademark of Capital One. Post Office Limited is an appointed representative of Capital One (Europe) Plc which is authorised and regulated by the Financial Conduct Authority. Capital One (Europe) Plc Registered Office: Trent House, Station Street, Nottingham NG2 3HX. Registered in England and Wales (No. 3879023). VAT Registration Number 690686101.
        </p>
        <p class="pt-4">
          Capital One<sup>®</sup> is the exclusive lender and issuer of all new Post Office Credit Cards, for which Post Office acts as credit broker. Post Office Limited is registered in England and Wales (No. 2154540). Registered office: 100 Wood Street, London, EC2V 7ER. Post Office and the Post Office logo are registered trademarks of Post Office Limited.
        </p>
        <p class="pt-4">
          <sup>*</sup> SMS - Short Message Service.
        </p>
        <p class="pt-4">
          <sup>*</sup> APR - Annual Percentage Rate.
        </p>
        <p class="pt-4">
          <sup>*</sup> P.A - Per Annum.
        </p>
      </div>
    </div>
    <div class="ie-footer container flex flex-wrap items-center justify-between max-w-5xl pt-4 pb-4 mx-auto">
      <div class="w-6/12 mx-auto text-center text-white lg:w-1/12 lg:mr-6">
        <Logo alt="Post Office Credit Card QuickCheck" class="inline-block w-16 ml-4 mr-5 sm:block sm:ml-0"></Logo>
      </div>
      <div class="flex-grow block md:flex md:items-center md:w-auto">
        <div class="flex w-9/12 mx-auto text-lg text-center lg:w-full lg:flex-grow">
          <a id="privacypage" href="https://www.postoffice.co.uk/privacy" target="_blank" class="block mt-3 mr-4 lg:inline-block lg:mt-0 hover:text-polred">
            Privacy Policy
          </a>
          <a id="accessibilitypage" href="https://www.postoffice.co.uk/accessibility" target="_blank" class="block mt-3 mr-4 lg:inline-block lg:mt-0 hover:text-polred">
            Accessibility
          </a>
          <a id="cookiepage" href="https://www.postoffice.co.uk/cookie-policy" target="_blank" class="block mt-3 lg:inline-block lg:mt-0 text-m hover:text-polred ">
            Cookies Policy
          </a>
        </div>
      </div>
    </div>
    <footer class="flex flex-wrap items-center justify-between p-2 pt-3 bg-polred">
      <div class="container flex flex-wrap items-center justify-between max-w-5xl mx-auto">
        <p class="text-white">Copyright {{ year }} The Post Office</p>
      </div>
    </footer>
  </div>
</template>

<script>

import CapitalOneLogo from '@/v2/assets/images/logos/capital-one.svg'
import Logo from '@/v2/assets/images/logos/post-office.svg'

export default {
  name: 'Footer',
  components: {
    CapitalOneLogo,
    Logo
  },
  data(){
    return {
      year: new Date().getFullYear()
    }
  }
}

var currentQueryString = window.location.search;
var currentHost = location.protocol+"//"+location.hostname;

window.onload = function () {
  if (currentQueryString) {
    document.getElementById("privacypage").href = currentHost + "/privacy" + currentQueryString; 
    document.getElementById("accessibilitypage").href = currentHost + "/accessibility" + currentQueryString; 
    document.getElementById("cookiepage").href = currentHost + "/cookie-policy" + currentQueryString; 
  } else {
    document.getElementById("privacypage").href = currentHost + "/privacy"; 
    document.getElementById("accessibilitypage").href = currentHost + "/accessibility";
    document.getElementById("cookiepage").href = currentHost + "/cookie-policy";
  }
}

</script>

<!-- Add "scoped" a
ttribute to limit CSS to this component only -->
<style scoped>

.capital-one-logo {
  position: relative;
  top: -4px;
}

</style>
